import { useParams } from 'react-router';

import { useFetchCustomDomainQuery } from '../services/api/customDomainApi/customDomain';

export function useCustomDomain() {
  const { organisationId } = useParams();

  return useFetchCustomDomainQuery(organisationId, {
    skip: !organisationId,
  });
}
